import { render } from "./LinkExpiredView.vue?vue&type=template&id=457bd436&ts=true"
import script from "./LinkExpiredView.vue?vue&type=script&lang=ts"
export * from "./LinkExpiredView.vue?vue&type=script&lang=ts"

import "./LinkExpiredView.vue?vue&type=style&index=0&id=457bd436&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__